export function getQueryFromUrl(query) {
  const urlParamMatch = window.location.search.match(new RegExp(`(^|[?&])${query}=([^&]+)`))
  return urlParamMatch ? urlParamMatch[2] : null
}

export function getPathFromUrl(url) {
  return url.split(document.body.dataset.locale)[1]
}

export function getLocale(pathname) {
  const match = pathname.match(/\/?([a-z]{2})-([a-z]{2})/)
  return match && match[1] && match[2] ? `${match[1]}-${match[2]}` : ''
}

export function getSlug(url, urlPath) {
  const splitUrl = url.split('/')
  const slugIndex = splitUrl.indexOf(urlPath) + 1 // url looks like /.../.../URL_PATH/slug
  return splitUrl[slugIndex] || ''
}

export const getSlugFromGroupName = groupName => groupName.toLowerCase().replace(/\W+/gi, '-')
